import "../playbutton.css";

export default function PlayButton({ paused, ...props }) {
  return (
    <button class={`play-pause-button ${paused ? "paused" : ""}`} {...props}>
      <i>P</i>
      <i>l</i>
      <i>a</i>
      <i>y</i>
      <i>use</i>
    </button>
  );
}
